import React, { useContext} from "react";
import { observer } from "mobx-react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { LiveSideNavigationInteractionTypeEnum } from "@data-types/analytics-tracker/LiveSideNavigationTypeEnum";
import { LiveEventSideMenuContext } from "@state/context/live/live-event-side-menu/LiveEventSideMenuContext";
import { analyticsTracker } from "@utils/analytics";

export const NavigationItemTwo = observer(function NavigationItemTwo(props: {
	culture: string;
}) {
	const liveEventMenuStore = useContext(LiveEventSideMenuContext);

	const { t } = useTranslation();

	return (
		<li className="nav--secondary__item nav--live__item">
			<NavLink
				className="nav--secondary__link"
				activeClassName="is-expanded"
				to={`/${props.culture}/live/upcoming`}
				onClick={() =>
					analyticsTracker.trackLiveSideNavigationInteraction(
						LiveSideNavigationInteractionTypeEnum.Upcoming
					)
				}
			>
				<div className="nav--secondary__icon">
					{liveEventMenuStore.upcomingEventsCount > 0 && (
						<span className="nav--secondary__counter counter counter--rounded counter--rounded--base counter--secondary counter--sup">
							{liveEventMenuStore.upcomingEventsCount}
						</span>
					)}

					<i className="nav--secondary__icon u-icon u-icon--lrg u-icon--upcoming" />
				</div>

				<div className="nav--secondary__title">
					{t<string>("LIVE.SIDEMENU.UPCOMING")}
				</div>
			</NavLink>
			<NavLink
				className="nav--secondary__link"
				activeClassName="is-expanded"
				to={`/${props.culture}/live/highlights`}
				onClick={() =>
					analyticsTracker.trackLiveSideNavigationInteraction(
						LiveSideNavigationInteractionTypeEnum.Highlights
					)
				}
			>
				<div className="nav--secondary__icon">
					{liveEventMenuStore.highlightsCount > 0 && (
						<span className="nav--secondary__counter counter counter--rounded counter--rounded--base counter--secondary counter--sup">
							{liveEventMenuStore.highlightsCount}
						</span>
					)}

					<i className="nav--secondary__icon u-icon u-icon--lrg u-icon--live-highlights" />
				</div>

				<div className="nav--secondary__title">
					{t<string>("LIVE.SIDEMENU.HIGHLIGHTS")}
				</div>
			</NavLink>
			{liveEventMenuStore.liveStreamEventCount > 0 ? (
				<NavLink
					className="nav--secondary__link"
					activeClassName="is-expanded"
					to={`/${props.culture}/live/live-stream`}
					onClick={() =>
						analyticsTracker.trackLiveSideNavigationInteraction(
							LiveSideNavigationInteractionTypeEnum.LiveStream
						)
					}
				>
					<div className="nav--secondary__icon">
						<span className="nav--secondary__counter counter counter--rounded counter--rounded--base counter--secondary counter--sup">
							{liveEventMenuStore.liveStreamEventCount}
						</span>

						<i className="nav--secondary__icon u-icon u-icon--lrg u-icon--live-stream" />
					</div>

					<div className="nav--secondary__title">
						{t<string>("SIDE_MENU.EVENTS_WITH_LIVE_STREAM")}
					</div>
				</NavLink>
			) : null}
		</li>
	);
});
